import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../../../Routes/ImagePath";
import axios from "axios";
import { Api_Url } from "../../../../../config/config";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const validationSchema = Yup.object().shape({
  mobile: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
});

const LoginWithMobile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(`${Api_Url}api/Account/login-with-mobile`, data);
      console.log("res", response.data);
      if (response.status === 200) {
        navigate('/otp', { state: { user: response.data.data, mobile: data.mobile } });
        // SuccessToast("Login Successfully")
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error("error", error);
    }
    finally {
      setLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    setValue("mobile", localStorage.getItem("mobile") || "");
  }, []);

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            {/* <Link to="/job-list" className="btn btn-primary apply-btn">
              Apply Job
            </Link> */}
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img src={Applogo} alt="Roha housing" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  <p className="account-subtitle">Access to our dashboard</p>
                  {/* Account Form */}
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-4">
                        <label className="col-form-label">Login with Mobile</label>
                        <input
                          className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                          type="number"
                          {...register("mobile")}
                        />
                        <span className="text-danger">
                          {errors.mobile?.message}
                        </span>
                      </div>
                      <div className="input-block text-center">
                        <button className="btn btn-primary account-btn" type="submit" disabled={loading}>
                          Login
                        </button>
                      </div>
                    </form>
                    {loading && (
                      <div className="text-center mt-3">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    )}
                    <div className="account-footer">
                      <p>
                        Login With Email{" "}
                        <Link to="/login">Email</Link>
                      </p>
                    </div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWithMobile;








// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";

// // import { Controller, useForm } from "react-hook-form";
// // import * as Yup from "yup";
// // import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
// // import { useDispatch } from "react-redux";
// // import { login } from "../../../user";
// // import { resetFunctionwithlogin } from "../../../components/ResetFunction";
// import { Applogo } from "../../../../../Routes/ImagePath";
// // import Login from "../../../Authentication/Login";
// import axios from "axios";
// import { Api_Url } from "../../../../../config/config";
// // import { login } from "../../../user";

// // const validationSchema = Yup.object().shape({
// //   email: Yup.number().min(10).required("Number is required"),
// // });

// const LoginWithMobile = () => {

// const [mobile,setMobile]= useState('')

// const navigate = useNavigate()


// //   const {
// //     register,
// //     control,
// //     setValue,
// //     handleSubmit,
// //     formState: { errors },
// //   } = useForm({
// //     resolver: yupResolver(validationSchema),
// //   });
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();
// //   const [emailError, setEmailError] = useState(false);

//   // const onSubmit = (data) => {
//   //   const currentUser = loginData?.find((item) => item?.email === data?.email);
//   //   if (!currentUser) {
//   //     setEmailError(true); // Email is not registered
//   //     navigate("/");
//   //   } else if (currentUser.password === data?.password) {
//   //     setEmailError(false); // Email is registered, and password is correct
//   //     const Value = {
//   //       email: data?.email,
//   //       password: data?.password,
//   //     };
//   //     dispatch(login(Value));
//   //     localStorage.setItem("credencial", JSON.stringify(Value));
//   //     navigate("/admin-dashboard");
//   //     resetFunctionwithlogin();
//   //   } else {
//   //     setEmailError(true); // Email is registered, but the password is incorrect
//   //     navigate("/");
//   //   }
//   // };

// //   function refreshPage() {
// //     window.location.reload(false);
// //   }

// //   const onSubmit = () => {
// //     localStorage.setItem("colorschema", "orange");
// //     localStorage.setItem("layout", "vertical");
// //     localStorage.setItem("layoutwidth", "fixed");
// //     localStorage.setItem("layoutpos", "fluid");
// //     localStorage.setItem("topbartheme", "light");
// //     localStorage.setItem("layoutSized", "lg");
// //     localStorage.setItem("layoutStyling", "default");
// //     localStorage.setItem("layoutSidebarStyle", "dark");

// //     navigate("/admin-dashboard");
// //   };

// //   useEffect(() => {
// //     setValue("email", localStorage.getItem("email"));
// //     setValue("password", localStorage.getItem("password"));
// //   }, []);

// //   const [eye, setEye] = useState(true);

// //   const onEyeClick = () => {
// //     setEye(!eye);
// //   };


// const handleSubmit = async()=>{
// try {
//     const data= {mobile}
//     console.log(data)
//       const response = await axios.post(`${Api_Url}api/Account/login-with-mobile`,data,)
//       console.log("res",response.data)
//       if (response.status === 200) {
//         navigate('/roles')
//       }else {
//         navigate('/')
//       }
//       // sessionStorage.setItem(JSON.stringify("user",response.data))
// } catch (error) {
//     console.log("error",error)
// }
// }

// // const handleSubmit = async () => {
// //     try {
// //       if (!mobile) {
// //         console.error('Mobile number is not defined.');
// //         return;
// //       }
      
// //       const data = { mobile };
// //     //   console.log(data);
// //       const response = await axios.post(
// //         'https://uatapi.rohahousing.org/api/Account/login-with-mobile',
// //         data
// //       );
// //       console.log('res', response.data);
// //     } catch (error) {
// //       console.log('error', error);
// //     }
// //   };
  

//   return (
//     <div>
//       <div className="account-page">
//         <div className="main-wrapper">
//           <div className="account-content">
//             <Link to="/job-list" className="btn btn-primary apply-btn">
//               Apply Job
//             </Link>
//             <div className="container">
//               {/* Account Logo */}
//               <div className="account-logo">
//                 <Link to="/admin-dashboard">
//                   <img src={Applogo} alt="Roha housing" />
//                 </Link>
//               </div>
//               {/* /Account Logo */}
//               <div className="account-box">
//                 <div className="account-wrapper">
//                   <h3 className="account-title">Login</h3>
//                   <p className="account-subtitle">Access to our dashboard</p>
//                   {/* Account Form */}
//                   <div>
//                     <form>
//                       <div className="input-block mb-4">
//                         <label className="col-form-label">Login with Mobile</label>
//                             <input
//                               className={`form-control`}
//                               type="text"
//                               onChange={(e)=>setMobile(e.target.value)}
//                               value={mobile}
//                             />
                      

//                         <span className="text-danger">
                          
//                         </span>
//                       </div>
//                       <div className="input-block text-center">
//                         <button
//                           className="btn btn-primary account-btn"
//                           type="button"
//                           onClick={handleSubmit}
//                         >
//                           Login
//                         </button>
//                       </div>
//                     </form>
//                     <div className="account-footer">
//                       <p>
//                         Login With Email{" /*"}
//                         <Link to="/login">Email</Link>
//                       </p>
//                     </div>
//                   </div>
//                   {/* /Account Form */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginWithMobile;
